module.exports = __webpack_public_path__ + "static/media/stairs.6882a402.svg";